/**
 * Text to show for a failed save or run (pam-deacon apps/MIGRATING.md V.9).
 *
 * On the statuses the scenario server answers with readable text (400, 404, 409,
 * 503) the backend's own words win: a writer conflict's ``message`` (its ``error``
 * is the code ``version_conflict``), otherwise ``error``. Any other 502/503/504 came
 * from a gateway or the SWA Function, not the app, and the write may still have
 * gone through, so it gets ``unknown`` and never "nothing was saved". So does a
 * request that got no answer at all (timeout, dropped connection).
 */
export const SAVE_OUTCOME_UNKNOWN =
  'The server did not confirm the save, so it may or may not have gone through. ' +
  'Reload to check before saving again.';

export const RUN_OUTCOME_UNKNOWN =
  'The server did not confirm the run, so it may have started. ' +
  'Check the run status before submitting again.';

const APP_TEXT_STATUSES = [400, 404, 409, 503];
const GATEWAY_STATUSES = [502, 503, 504];

export const serverErrorText = (error, { fallback, unknown }) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const text = data && typeof data === 'object' ? data.message || data.error : null;
  if (APP_TEXT_STATUSES.includes(status) && typeof text === 'string' && text.trim()) {
    return text;
  }
  if (GATEWAY_STATUSES.includes(status)) return unknown;
  if (error?.request && !error.response) return unknown;
  return fallback;
};

export const isConflict = (error) => error?.response?.status === 409;
